export default __webpack_public_path__ + "static/media/sophos.9b8af980.png";